// extracted by mini-css-extract-plugin
export default {"plans":"Plans_plans__EEfMI","tabWrapper":"Plans_tabWrapper__tPBeW"};